import { ChangeDetectorRef, Component, Input, OnInit, HostBinding } from '@angular/core';
import { ApiService } from 'src/app/services/api/api.service';
import SwiperCore, { Pagination, EffectFade, Autoplay } from 'swiper/core';
import { environment } from 'src/environments/environment';

// Enable Swiper Paginate, Fade Effect and Autoplay

SwiperCore.use([Pagination, EffectFade, Autoplay]);

@Component({
    selector: 'app-pb-promotions-slider',
    templateUrl: './pb-promotions-slider.component.html',
    styleUrls: ['./pb-promotions-slider.component.scss']
})
export class PbPromotionsSliderComponent implements OnInit {

    @Input() content: any = {};
    @Input() module: any = {};
    padding_top: any = '';
    padding_bottom: any = '';
    items: any = [];

    swiperInstance: any;
    isBegin = true;
    isEnd = false;
    domainUrl: string = environment.webUrl;

    slides: any = [];

    constructor() { }

    ngOnInit(): void {

        this.content.forEach(element => {
            const item = {
                content: element.data,
                alignment: this.determineAlignment(element.alignment),
                padding: this.determinePadding(element.padding),
                type: element.item.type,
                image: ''
            };

            try {
                item.content = JSON.parse(item.content);
            } catch (err) { }

            if (item.content.image !== '') {
                item.image = this.domainUrl + '/' + item.content.image;
            }

            this.slides.push(item);
        });

        this.padding_top = this.module.padding_top; // Module Padding
        this.padding_bottom = this.module.padding_bottom;

    }

    @HostBinding('attr.style')
    public get cssVars() {
        return `
            --bg_color: ${this.slides[0].content?.bg_color ? this.slides[0].content?.bg_color : '#13426d' };
            --bg_color_2: ${this.slides[0].content?.bg_color_2 ? this.slides[0].content?.bg_color_2 : '#337ec2' };
        `;
    }

    /**
     * Alignment is returned as LEFT, CENTER, RIGHT
     * Determine class based on response
     */
    determineAlignment(alignment) {

        if (alignment === 'LEFT') {
            return 'text-left';
        } else if (alignment === 'CENTER') {
            return 'text-center';
        } else if (alignment === 'RIGHT') {
            return 'text-right';
        }

    }

    /**
     * Padding is returned as SMALL, MEDIUM, LARGE, XLARGE
     * Determine pixels based on response
     */
    determinePadding(padding) {

        if (padding === 'SMALL') {
            return '10';
        } else if (padding === 'MEDIUM') {
            return '15';
        } else if (padding === 'LARGE') {
            return '30';
        } else if (padding === 'XLARGE') {
            return '60';
        }

    }

    /**
     * When 'Skills on Demand' swiper is ready then run the update so that the slide size is correct
     * @param swiper
     */
    onSkillsSwiper(swiper) {

        this.swiperInstance = swiper;

        setTimeout(() => {
            //  swiper.update();
        }, 1500);

    }

    /**
     * Using slidechange to disable / enable the next and previous buttons
     */
    onSlideChange() {

        this.isBegin = this.swiperInstance.isBeginning;
        this.isEnd = this.swiperInstance.isEnd;

    }

    /**
     * Slides to the next image
     */
    gotoNext() {

        this.swiperInstance.slideNext();

    }

    /**
     * Slides to the previous image
     */
    gotoPrevious() {

        this.swiperInstance.slidePrev();

    }

}
